import {
  Container,
  ContainerGutter,
  ContainerPadding,
  TokenTextAppearance,
  Text,
  styled,
  TextTag,
} from '@volkswagen-onehub/components-core';
import React, { PropsWithChildren } from 'react';
import {VolksKlickBrand} from '../svg/VolksKlick/Brand';
import {getTranslations} from '../translations';

const BuildYourDealModalContainer = styled.div`
  text-align: center;
`;

const VKWrapper: React.FC<PropsWithChildren> = ({children}) => {
  const trans = getTranslations();

  return (
    <Container
      wrap="always"
      gutter={ContainerGutter.dynamic0100}
      stretchContent
    >
      <BuildYourDealModalContainer>
        <Container
          gutter={ContainerGutter.static250}
          wrap="always"
          horizontalAlign="center"
          padding={{
            top: ContainerPadding.dynamic0140,
            right: ContainerPadding.dynamic0100,
            bottom: ContainerPadding.dynamic0140,
            left: ContainerPadding.dynamic0100,
          }}
        >
          <VolksKlickBrand color="#001E50" />
          <Text appearance={TokenTextAppearance.headline400} bold>
            {trans.details.motoinsights.header}
          </Text>

          <Text tag={TextTag.p}>{trans.details.motoinsights.copy}</Text>

          {children}
        </Container>
      </BuildYourDealModalContainer>
    </Container>
  );
};

export default VKWrapper;
